import { notification } from 'antd';
import _ from 'lodash';

import { AppDispatch } from '../../../store';
import { appLoadingStarted, appLoadingStopped, appLoadingTextChanged } from '../../../store/appLoading';
import { ocrDataUpdated, ocrStepUpdated } from '../../../store/impOcr';
import { errDescGeneral, errMsgGeneral } from '../../../utils/helpers/errorTexts';
import { createMultiPage } from '../createMultiPage';
import { createOcrItems } from '../createOcrItems';
import { DocTypes } from '../docTypes';
import { ocrCategorize } from './ocrCategorize';
import { getImagesForOcr } from './pdfToImage';


export const importPdf = async ({
  files,
  dispatch,
  isPL = true
}: {
  files: File[],
  dispatch: AppDispatch
  isPL: boolean
}) => {
  try {
    dispatch(appLoadingStarted());

    document.body.classList.add('no-scroll');

    const fileError = isPL ? 'Plik jest niewłaściwy, albo zawiera błędy.' :
      'The file is incorrect or contains errors';

    if (_.isEmpty(files)) throw new Error(fileError);


    const checkFileError = isPL ?
      'Co najmniej jeden plik ma nieprawidłowy format' :
      'At least one file has an incorrect format';

    checkFilesType(files, checkFileError);

    const analyzeText = isPL ? 'analizuję pliki' : 'analyzing files';

    dispatch(appLoadingTextChanged(analyzeText));

    const images = await getImagesForOcr(files);

    const docsWithCategory = await ocrCategorize({
      images,
      dispatch,
      isPL
    });

    const withoutBlank = docsWithCategory.reduce((prev:{
      input: string;
      output: DocTypes;
      image: string;
    }[], curr) => {
      if (curr.input === '') return prev;
      return [
        ...prev,
        curr
      ];
    }, []);

    const refactoredDocs = createMultiPage(withoutBlank);

    const ocrItems = await createOcrItems(refactoredDocs);

    dispatch(ocrDataUpdated(ocrItems));

    dispatch(ocrStepUpdated(1));

  } catch (error) {
    if (error instanceof Error){
      notification.error({
        message: errMsgGeneral, description: error.message
      });
    } else {
      notification.error({
        message: errMsgGeneral, description: errDescGeneral
      });
    }
  } finally {
    document.body.classList.remove('no-scroll');
    dispatch(appLoadingStopped());
  }
};


const checkFilesType = (
  files: File[],
  text: string
) => {
  files.forEach(({ type }) => {
    if (type !== 'application/pdf'
    && type !== 'image/png'
    && type !== 'image/jpg'
    && type !== 'image/jpeg'
    ) {
      throw new Error(text);
    }
  });
};
